import { css } from '@emotion/core';
import { tokens } from '@domain-group/design-tokens';
import { fontSmall } from '../typography/typography-scale';
export default /*#__PURE__*/css(fontSmall, ";display:inline-block;padding:3px 10px;border-radius:3px;background:", tokens.colors.neutral.heavy.default, ";color:", tokens.colors.neutral.surface.default, ";letter-spacing:0.5px;");